let functions = {};

try {
    const mod = 'revelr';
    window.localStorage.setItem(mod, mod);
    window.localStorage.removeItem(mod);

    functions = {
        setItem: window.localStorage.setItem.bind(window.localStorage),
        getItem: window.localStorage.getItem.bind(window.localStorage),
    };
} catch (e) {
    functions = {
        setItem() { return; },
        // Returns null if key doesn't exist:
        // https://developer.mozilla.org/en-US/docs/Web/API/Storage/getItem
        getItem() { return null; },
    };
}

export const setItem = functions.setItem;
export const getItem = functions.getItem;



// WEBPACK FOOTER //
// ./app/assets/javascripts/utils/localStorage.jsx